// Картинки сообщения (этап 31). История и открытие чата приходят со ссылками
// (`imageUrls`, пути относительно корня API): страница весит килобайты, а картинки
// браузер берёт по мере прокрутки и держит в кэше. Живые ответы, события и свои
// неотправленные сообщения по-прежнему несут data URL (`imageDataUrls`/`imageDataUrl`).
import { config } from './config.js';

export function messageImages(message) {
  if (Array.isArray(message?.imageUrls) && message.imageUrls.length) {
    return message.imageUrls.map((path) => `${config.apiUrl}${path}`);
  }
  if (message?.imageDataUrls?.length) {
    return message.imageDataUrls;
  }
  return message?.imageDataUrl ? [message.imageDataUrl] : [];
}

// Этап 32: лента и печать показывают миниатюру (до 1024 px по большей стороне, поворот
// по EXIF уже применён): оригиналы бывают по 3 МБ и 12 Мп — на iPhone это путь к вылету
// по памяти. Повторная отправка берёт оригинал (messageImages).
export function messageThumbnails(message) {
  if (Array.isArray(message?.imageUrls) && message.imageUrls.length) {
    return message.imageUrls.map((path) => `${config.apiUrl}${path}${path.includes('?') ? '&' : '?'}size=thumb`);
  }
  return messageImages(message);
}

// Данные картинки для повторной отправки: backend принимает в запросе только data URL,
// поэтому ссылку скачиваем (обычно из кэша браузера) и перекодируем.
export async function toDataUrl(src) {
  if (!src || src.startsWith('data:')) {
    return src;
  }
  const response = await fetch(src, { credentials: 'same-origin' });
  if (!response.ok) {
    throw new Error(`image ${response.status}`);
  }
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('image read failed'));
    reader.readAsDataURL(blob);
  });
}

// По одной: iOS WebKit роняет параллельные fetch.
export async function toDataUrls(sources) {
  const result = [];
  for (const src of sources) {
    result.push(await toDataUrl(src));
  }
  return result;
}
